// Shared API client for the Web app. Hits the Worker via Vite proxy in dev,
// and the same-origin Pages Function in prod.

// In dev: Vite proxies /api → wrangler dev. In prod: VITE_API_BASE points
// at the deployed Worker (e.g. https://gcsd-hub-worker.<account>.workers.dev).
const BASE = (import.meta.env.VITE_API_BASE as string | undefined) ?? '';

export async function api<T>(path: string): Promise<T> {
  const res = await fetch(`${BASE}/api${path}`, { credentials: 'include' });
  if (!res.ok) throw new Error(`api_${res.status}: ${path}`);
  return (await res.json()) as T;
}
